module.exports = __webpack_public_path__ + "static/img/btn_fixtour.7927df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etc/btn_fixtour.png
// module id = 4uPG
// module chunks = 1